import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import './i18n'; // initialize i18next (side-effect) before any component renders
import theme from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import { BrandProvider } from './contexts/BrandContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { CreditProvider } from './contexts/CreditContext';
import { ToastProvider } from './contexts/ToastContext';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import App from './App';
import ManagementApp from './ManagementApp';

// GTM is injected into index.html at BUILD time by the gtmPlugin in
// vite.config.ts (gated on VITE_GTM_CONTAINER_ID, set only in
// .env.production). It is deliberately NOT installed from here — see that
// plugin's comment for why Tag Assistant can't see a runtime-injected tag.

// management.traaker.ai (or management.dev.traaker.ai) renders the internal
// ops shell. For local dev, set VITE_APP_MODE=management.
const isManagement =
  window.location.hostname.startsWith('management.') ||
  import.meta.env.VITE_APP_MODE === 'management';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            {isManagement ? (
              <ToastProvider>
                <ManagementApp />
              </ToastProvider>
            ) : (
              <BrandProvider>
                <NotificationsProvider>
                  <CreditProvider>
                    <ToastProvider>
                      <App />
                    </ToastProvider>
                  </CreditProvider>
                </NotificationsProvider>
              </BrandProvider>
            )}
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
);
